import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { PixelsScroller } from '@/components/landing/pixels-scroller'
import { offerings } from '@/constants/offerings'

const Home: FC = (): ReactNode => {
    return (
        <Layout fixed indexLabel={`Index 0${offerings.length}`}>
            <Seo description='A subscription library of premium, motion-first web sections. Few, but flawless.' />

            <PixelsScroller />
        </Layout>
    )
}

export default Home
